import type { Dispatch} from 'react';
import { useCallback, useState } from 'react';
import type { ErrorBoxType } from '../generic/ErrorBox';
import type { ValidationErrors } from '../model/types';
import { getValidationErrors, isValidationErrors } from './validation';

export function useValidationErrors<T extends string>(): [error: ErrorBoxType | undefined, validation: ValidationErrors<T>, Dispatch<any>] {
    const [error, setError] = useState<ErrorBoxType>();
    const [validation, setValidation] = useState<ValidationErrors<T>>({});

    const dispatch = useCallback((error: any) => {
        if (isValidationErrors(error)) {
            setValidation(getValidationErrors(error));
            setError(undefined);
            setTimeout(() => {
                const element = document.querySelector('[aria-invalid="true"]') as HTMLElement;
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 100);
        } else {
            setError(error);
            setValidation({});
        }
    }, []);

    return [error, validation, dispatch];
}
